import { FC } from "react"
import { BatchDelete } from "../../../module/travelers/containers/batchDelete/index"

export const TravelersBatchDeletePage: FC = () => <BatchDelete />
